const en_contract = {
    add: "Add Contract",
    edit: "Edit Contract",
    detail: "Contract Details",

    label: {
        contract_date: "Contract Date",
        contract_num: "Contract No.",
        contract_period: "Contract Period",
        contract_amout: "Contract Value",
        contract_content: "Contract Terms",
    },

    message: {
        delete_po_title: "Are you sure you want to cancel the contract?",
        delete_po_text: "Enter the reason for canceling the contract.",

        reject_po_title: "Are you sure you want to reject the contract?",
        reject_po_text: "Enter the reason for rejecting the contract.",
    },

    error: {
        create: "Failed to create contract.",
        delete: "Failed to cancel contract.",
        edit: "Failed to edit contract.",
    },

    success: {
        create: "Contract created successfully.",
        delete: "Contract canceled successfully.",
        edit: "Contract updated successfully.",
    },
}

export default en_contract;